import * as filters from './filters/reducer'
import * as table from './table/reducer'
import * as tableViolations from './tableViolations/reducer'
import * as tableDeviations from './tableDeviations/reducer'


export default {
  filters,
  table,
  tableViolations,
  tableDeviations,
}
